import Axios from "./axiosInstance";

export const configurationAPI = {
  // Get all records
  getAll(slug, params = {}) {
    return Axios.get(`/${slug}`, { params });
  },

  // Get record by ID
  getById(slug, id) {
    return Axios.get(`/${slug}/${id}`);
  },

  // Create a new record
  add(slug, data) {
    return Axios.post(`/${slug}`, data);
  },

  // Update existing record
  update(slug, id, data) {
    if (data instanceof FormData) {
      if (!data.has("_method")) {
        data.append("_method", "PUT");
      }
      return Axios.post(`/${slug}/${id}`, data);
    }
    return Axios.put(`/${slug}/${id}`, data);
  },

  // Delete record
  remove(slug, id) {
    return Axios.delete(`/${slug}/${id}`);
  },

  // Change active/inactive status
  changeStatus(slug, id, status) {
    return Axios.post(`/${slug}/change-status/${id}`, { is_active: status });
  },

  // Update sequence
  updateSequence(slug, data) {
    return Axios.post(`/${slug}`, data);
  },
};
